/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ComputeResourceState = {
  Requested: "requested",
  Allocating: "allocating",
  Provisioning: "provisioning",
  Running: "running",
  Ready: "ready",
  Finalizing: "finalizing",
  Terminating: "terminating",
  Succeeded: "succeeded",
  Failed: "failed",
  Terminated: "terminated",
} as const;
export type ComputeResourceState = ClosedEnum<typeof ComputeResourceState>;

/** @internal */
export const ComputeResourceState$inboundSchema: z.ZodNativeEnum<
  typeof ComputeResourceState
> = z.nativeEnum(ComputeResourceState);
/** @internal */
export const ComputeResourceState$outboundSchema: z.ZodNativeEnum<
  typeof ComputeResourceState
> = ComputeResourceState$inboundSchema;
